const layout = () => import("../../external/layout.vue");
const home = () => import("./home.vue");

const homeRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "home",
      component: home,
    },
  ],
};

export default homeRoutes;